export enum LocalStorageKey {
    TICKET_SELECTED = "TICKET_SELECTED",
    QUEUE_QR_PAYMENTS = "QUEUE_QR_PAYMENTS",
    TICKET_UPGRADE = "TICKET_UPGRADE",
}